import { useEffect, useState } from "react";
// aos
import AOS from "aos";
import "aos/dist/aos.css";
import Layout from "../Layout/Layout";
import { viewNews } from "../../states/actions/newsAction";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Loading from "../loading/Loading";
import BaseUrl from "../../service/API/base_url";
import { ChevronRight } from "lucide-react";
import Profile from "../../assets/profile.jpg";
import { FormatDate } from "../Date/Date";

const SingleNews = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({ duration: 3000 });
  }, []);

  // dispatch
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { singleNews } = state || {};
  const [activeImg, setActiveImage] = useState();
  const [currentNews, setCurrentNews] = useState(singleNews || null);
  // console.log("News data : ", currentNews);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (singleNews) {
      setCurrentNews(singleNews);
      setLoading(false);
    }
  }, [singleNews]);
  const handleGetNews = (data) => {
    window.scrollTo(0, 0);
    setCurrentNews(data);
    setActiveImage(`${BaseUrl}${data.photo}`);
  };

  // hooks
  const News = useSelector((state) => state.News);
  // use effect
  useEffect(() => {
    dispatch(viewNews());
  }, []);

  const [originalData, setOriginalData] = useState([]);
  const [data, setData] = useState([]);

  //change useselector data to useState states with react js
  useEffect(() => {
    setOriginalData(News?.News || []);
    setData(News?.News || []);
  }, [News?.News]);

  const [selectedOption, setSelectedOption] = useState(null);
  // searching state
  const [isSearching, setIsSearching] = useState(false);

  useEffect(() => {
    let timer;
    if (isSearching) {
      timer = setTimeout(() => {
        setIsSearching(false);
      }, 3000); // stop searching after 30s
    }
    return () => clearTimeout(timer);
  }, [isSearching]);

  const handleTypeSelect = (selected) => {
    setSelectedOption(selected);

    if (!selected) {
      // If selection is cleared, show all data again
      setData(originalData);
    } else {
      filterResult(selected.value);
    }
  };

  const filterResult = (catData) => {
    const result = originalData.filter(
      (curData) => curData?.internshipCategory === catData,
    );
    setData(result);
  };

  // --- Post Card ---
  const PostCard = () => (
    <div className="bg-white border border-gray-200 mb-12 p-2 md:p-4">
      <img
        src={activeImg || `${BaseUrl}${currentNews?.photo}`}
        alt="single news"
        className="w-full h-[260px] md:h-[360px] object-cover"
      />

      <div className="p-6 md:p-8">
        <div className="flex flex-wrap items-center gap-3 text-xs text-gray-500 mb-4">
          <div className="flex items-center gap-2">
            <img
              src={Profile}
              alt="news image"
              className="w-7 h-7 rounded-full object-cover"
            />
            <span>{currentNews?.author}</span>
          </div>
          <div className="-translate-x-1/2 flex gap-2 z-20">
            <button
              className="w-2 h-2 rotate-45 bg-yellow-400 
             "
            />
          </div>
          <span>{FormatDate(currentNews?.createdAt)}</span>

          <div className="-translate-x-1/2 flex gap-2 z-20">
            <button
              className="w-2 h-2 rotate-45 bg-yellow-400 
             "
            />
          </div>
          <span className="flex flex-wrap gap-1">
            {currentNews?.categories?.map((c, i) => (
              <span key={i} className="hover:text-[#c6a47e] cursor-pointer">
                {c}
                {i !== currentNews?.categories.length - 1 && ","}
              </span>
            ))}
          </span>
        </div>

        <h2 className="text-xl md:text-2xl font-serif font-semibold text-gray-800 mb-4 leading-snug hover:text-[#c6a47e] cursor-pointer">
          {currentNews?.title}
        </h2>

        <p className="text-gray-600 text-sm leading-relaxed mb-6">
          {currentNews?.description}
        </p>
      </div>
    </div>
  );

  // --- Sidebar ---
  const Sidebar = () => (
    <div className="space-y-10">
      {/* Recent Posts */}
      <div className="border border-gray-200 p-5">
        <h3 className="font-semibold mb-4">Recent Posts</h3>
        <div className="space-y-4">
          {News?.News?.slice(0, 6).map((data) => (
            <div
              className="flex gap-3 items-center"
              onClick={() => handleGetNews(data)}
            >
              <img
                src={`${BaseUrl}/${data?.photo}`}
                alt="newd data"
                className="w-14 h-14 object-cover"
              />
              <div>
                <p className="text-sm font-medium leading-tight hover:text-[#c6a47e] cursor-pointer">
                  {data?.title}
                </p>
                <span className="text-xs text-gray-400">
                  {FormatDate(data?.createdAt)}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Categories with Arrow Icon */}
      <div className="border border-gray-200 p-5">
        <h3 className="font-semibold mb-4">Categories</h3>
        <ul className="text-sm text-gray-600 divide-y">
          {[
            "Criminal Law (4)",
            "Employment Law (6)",
            "Family Law (5)",
            "Financial Law (8)",
            "Vaccine Claims (6)",
          ].map((item, i) => (
            <li
              key={i}
              className="py-2 flex items-center justify-between group cursor-pointer"
            >
              <span className="group-hover:text-[#c6a47e]">{item}</span>
              <ChevronRight className="w-4 h-4 text-gray-400 group-hover:text-[#c6a47e]" />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );

  return (
    <Layout
      title="Nes Detail Page | Aderaw Addisu Law Office"
      description="Legal services in Bahir Dar including arbitration, litigation, contracts and consultation."
      keywords="Legal services Bahir Dar, Lawyer Ethiopia"
    >
      <section className="h-[40vh] md:h-[65vh] bg-gradient-to-b from-[#1e2f4a] to-[#0b1628] text-white flex items-center justify-center px-6">
        <div className="max-w-5xl w-full text-center">
          {/* Top Badge */}
          <div className="inline-block mb-6">
            <span className="text-[11px] tracking-widest uppercase px-5 py-2 rounded-full border border-yellow-500/40 text-yellow-400">
              ጠበቃ አደራው አዲሱ
            </span>
          </div>
          {/* Title */}

          <h1 className="text-4xl md:text-6xl font-light mb-6 leading-tight font-serif">
            News
            <span className="text-yellow-400 font-serif font-medium tracking-tight">
              Detail
            </span>
          </h1>
        </div>
      </section>

      <div className="bg-[#f8f8f8] min-h-screen py-10 px-4 md:px-10">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-10">
          <div className="lg:col-span-2">
            {loading ? (
              <Loading />
            ) : currentNews ? (
              <PostCard />
            ) : (
              <p className="text-center text-gray-500">News not found</p>
            )}
          </div>

          <div className="hidden lg:block">
            <Sidebar />
          </div>
        </div>

        <div className="lg:hidden mt-12">
          <Sidebar />
        </div>
      </div>
    </Layout>
  );
};
export default SingleNews;
